module.exports = __webpack_public_path__ + "static/img/cell4.3a2f481.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cell4.png
// module id = 90rF
// module chunks = 0